import React from 'react';
import { FadeIn } from '../components/ui/FadeIn';
import FeaturesGrid from '../components/home/FeaturesGrid';

const Features = () => {
  return (
    <div className="pt-20 pb-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center mb-16">
        <FadeIn>
          <h1 className="text-4xl md:text-6xl font-black mb-6 text-white drop-shadow-[0_2px_20px_rgba(255,255,255,0.2)]">
            Every feature you need to scale content
          </h1>
          <p className="text-lg text-white/70 max-w-2xl mx-auto drop-shadow-[0_2px_10px_rgba(0,0,0,0.5)]">
            From single YouTube videos to bulk processing enterprise webinar libraries
          </p>
        </FadeIn>
      </div>
      <FeaturesGrid />
    </div>
  );
};

export default Features;